/**
 * 列表的 AutoComplete搜索 + select 状态过滤 + Table + PageBar 部分抽象，组件部分
 */
import React, { Fragment } from 'react'
import { Table, Column } from '@tencent/spaui-table'
import Select from '@tencent/spaui-select'
import PageBar from '@tencent/spaui-pagebar'
import AutoComplete from '@tencent/spaui-autocomplete'
import Button from '@tencent/spaui-button'

const PureList = props => {
    const {
        columnsConfig = [],
        colRender,
        HeaderRightAddOn,
        title = '',
        showSearch = true,
        showPageBar = true,
        showAddBtn = false,
        addBtnText = '添加APP',
        searchPlaceholder = 'APP名称',
        filterTextInput,
        handleFilterTextClear,
        handlePageSizeChange,
        handleKeyPress,
        handleSearchIconClick,
        handleAddButtonClick = () => {},
        handleFilterChange = () => {},
        showFilter = true,
        filterPlaceholder = '状态',
        filterSelectData,
        filterSelectValue,
        handleFilterSelectOnchange = () => {},
        handlePageChange,
        loading,
        page,
        pageSize,
        totalSize,
        data,
        fixedHeight = 0,
        setCellStyle = () => {},
    } = props
    const defaultColRender = (type, name, value) => {
        return value
    }
    const getColumns = () => {
        const res = []
        columnsConfig.forEach(col => {
            res.push(
                <Column
                    name={col[0]}
                    className="col-cr with-popover"
                    align="left"
                    key={`table_list_column_${col[0]}`}
                    render={colRender || defaultColRender}
                >
                    {col[1]}
                </Column>
            )
        })

        return res
    }

    return (
        <Fragment>
            <div className={'titlebar with-addons'}>
                {title ? <h3 className="title">{title}</h3> : null}
                <div className="a-tabs-head-right">
                    <div className="toolbar">
                        <div className="toolbar-right">
                            <div className="toolbar-right-inner">
                                {showAddBtn ? (
                                    <Button
                                        className="spaui-add-button"
                                        displayType="primary"
                                        onClick={handleAddButtonClick}
                                    >
                                        {addBtnText}
                                    </Button>
                                ) : null}
                                {showSearch ? (
                                    <AutoComplete
                                        className="spaui-autocomplete"
                                        placeholder={searchPlaceholder}
                                        onChange={handleFilterChange}
                                        onKeyPress={handleKeyPress}
                                        value={filterTextInput}
                                        onClear={handleFilterTextClear}
                                        onClickSearchIcon={handleSearchIconClick}
                                        open={false}
                                    />
                                ) : null}
                                {showFilter ? (
                                    <Select
                                        placeholder={filterPlaceholder}
                                        data={filterSelectData}
                                        value={filterSelectValue}
                                        onChange={handleFilterSelectOnchange}
                                    />
                                ) : null}
                                {HeaderRightAddOn ? <HeaderRightAddOn /> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="datalist">
                <Table
                    data={data}
                    className="a-table"
                    bordered={false}
                    hover={false}
                    striped={false}
                    loading={loading}
                    loadingType="default"
                    fixedHeight={fixedHeight}
                    setCellStyle={setCellStyle}
                >
                    {getColumns()}
                </Table>
                {showPageBar ? (
                    <PageBar
                        value={page || 1}
                        pageSize={pageSize || 5}
                        totalSize={totalSize || 0}
                        pageSizeList={[10, 20, 50]}
                        onChange={handlePageChange}
                        onPageSizeChange={handlePageSizeChange}
                    />
                ) : null}
            </div>
        </Fragment>
    )
}

export default PureList
